import { ProductTypeType } from "shared";

const productTypeWordingMap: Record<ProductTypeType, string> = {
  CONSUMABLE: "Consommable",
  PACKING: "Emballage",
  OUTSOURCING: "Sous-traitance",
  CHILD: "Composant",
};

export const getProductTypeToRender = (productType?: ProductTypeType | null) => {
  if (!productType) {
    return "-";
  }

  return productTypeWordingMap[productType];
};
